import { render, staticRenderFns } from "./UploadCapturedImage.vue?vue&type=template&id=3df479c6&scoped=true"
import script from "./UploadCapturedImage.vue?vue&type=script&lang=js"
export * from "./UploadCapturedImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df479c6",
  null
  
)

export default component.exports